// extracted by mini-css-extract-plugin
module.exports = {"content":"IndicesMajors_content__iJF9J"};